import { DisplayValue } from "../details/tabs/types";
import { placeholder } from "./defaults";

export function createHyphenatedString(value: string): string {
  return value.trim().toLowerCase().replace(/\s+/g, "-");
}

export function isMissingDisplayValue(
  value: DisplayValue,
): value is null | undefined | "" {
  return value === undefined || value === null || value === "";
}

export function getDisplayValue(value?: DisplayValue): string {
  if (isMissingDisplayValue(value)) return placeholder;
  return String(value);
}

export const normaliseUrl = (value: string | undefined): string | null => {
  if (!value?.trim()) return null;
  if (value.startsWith("http://") || value.startsWith("https://")) return value;

  return `https://${value}`;
};
